import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AwsCostClient, awsCostApiRef } from './api';
import { rootRouteRef } from './routes';

export const costAnalysisPlugin = createPlugin({
  id: 'aws-cost',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: awsCostApiRef,
      deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
      factory: ({ discoveryApi, fetchApi }) =>
        new AwsCostClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const CostAnalysisPage = costAnalysisPlugin.provide(
  createRoutableExtension({
    name: 'CostAnalysisPage',
    component: () => import('./components').then(module => module.CostPage),
    mountPoint: rootRouteRef,
  }),
);
